import { Pictogram } from '@tuic/web-compositions/core/Pictogram';
import { FC, useEffect } from 'react';
import { Trans } from '@tuic/i18n';
import { captureErrorCode } from '@lib/sentry/capture-error-code';
import { ErrorCode, isErrorCode } from '@lib/errors/error-code';
import { useClientTranslation } from '@lib/i18n/client';
import { DialogBody } from '@modules/get-slash-internet-card/components/dialog-views/dialog-body';
type Props = {
  error: ErrorCode | string;
};
export const ErrorView: FC<Props> = props => {
  const {
    error
  } = props;
  const {
    t
  } = useClientTranslation();
  useEffect(() => {
    // Only capture if it's a valid ErrorCode
    if (isErrorCode(error)) {
      captureErrorCode(error, 'InternetCardDialogErrorView');
    }
  }, [error]);
  return <DialogBody data-sentry-element="DialogBody" data-sentry-component="ErrorView" data-sentry-source-file="error-view.tsx">
      <div className="space-y-6 text-center text-marine-80 text-marine-high-emphasis">
        <Pictogram name="lifebuoy" size="md" className="inline-block" data-sentry-element="Pictogram" data-sentry-source-file="error-view.tsx" />
        <div className="space-y-2">
          <div className="headline-sm">
            {t('Authentifizierung nicht möglich.')}
          </div>
          <div className="text-base [&_strong:font-semibold]">
            <Trans data-sentry-element="Trans" data-sentry-source-file="error-view.tsx">
              Die Administration Ihres Internettarifs ist derzeit nicht möglich.
              <br />
              <br />
              Bitte versuchen Sie es erneut unter{' '}
              <a href="https://internet.meinschiff.de" className="underline hover:no-underline" target="_blank">
                https://internet.meinschiff.de
              </a>{' '}
              im Browser. Wenden Sie sich anschließend mit dem Fehlercode #
              {{
              error
            } as any} an unseren Gästeservice.
            </Trans>
          </div>
        </div>
      </div>
    </DialogBody>;
};